import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {
  cloneVar,
  apiAuth,
  apiAuthMe,
  apiLogout,
  refreshToken,
  connectWebSocket,
  beepSound,
  initBase, sleep
} from './common/utils'
import router from "@/router";


Vue.use(Vuex)

const _user = {
  _id        : null,
  id         : null,
  nick       : null,
  name       : null,
  position   : null,
  role       : null,
  email      : null,
  phoneNo    : null,
  accessToken :null,
  tokenExpireMin: 0,
  centerCode : null,
  areas: null,
  userClass : 0
};

const state = {
  systemName: 'N/A',
  systemTag: 'N/A',
  systemBuildAt: 'N/A',
  systemVersion: 'N/A',
  serverConnected: false,
  // 로그인 후 기초 데이터(코드맵·탱크·지역·유종·경보설정) 적재 완료 여부. 라우팅이 이를 기다린다
  baseReady: false,
  largeFont: false,
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  darkMode: true,
  workstation: false,
  asideShow: false,
  numOfTankItem: 10,
  numOfMachineItem: 10,
  numOfInoutItem: 10,
  numOfTankStockItem: 10,
  numOfOilStockItem: 10,
  volUnit: 'g',
  lenUnit: 'i',
  tmpUnit: 'f',
  // ------------ below --- added for application ------------
  messageBarShow: false,
  messageBarMinimize: false,
  isAuth: false,
  expireSecIn: 0,
  // 사운드 설정. 로그인 후 한 번 고른 값은 localStorage 에 남겨 새로고침에도 유지한다 (로그아웃 시 삭제)
  soundOn: localStorage.getItem('soundOn') === '1',
  tankTrace: true,
  voice: null, // 목소리
  user: {
    _id        : null,
    id         : null,
    nick       : null,
    name       : null,
    position   : null,
    role       : null,
    email      : null,
    hpNo       : null,
    accessToken :null,
    tokenExpireMin: 0,
    centerCode  : null,
    areas: null,
    userClass : 0
  },
  socket: null,
  codeMaps: {},
  codeOpts: {},
  area: {},
  tanks: {},
  alarm: {
    count: {
      fromDays: 3,
      total: 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
    },
    config: {},
    tank: { },
    // 수신 경보 목록. 소켓 수신은 TheAside 가 담당하고 경보현황 화면과 공유한다.
    alerts: [],
    // 경보코드별 탱크 알람지연 정보 { code: { tid: 지연만료일시 } }
    suppress: {
      '1': null,
      '2': null,
      '3': null,
      '4': null,
      '5': null,
      '6': null,
      '7': null,
      '8': null,
      '9': null,
    },
  },
  updateStatus: {
    tank: { updated: false, appliedAt: null },
    tankTable: { updated: false, appliedAt: null },
    machine: { updated: false, appliedAt: null },
    alarm: { updated: false, appliedAt: null },
  },
  serverLiveness: false,
  // ------------ above --- added for application ------------

}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    // console.log( 'store.set() --- register global variable ---', variable);
    state[variable] = value
  },
  async toggle (state, variable) {
    state[variable] = !state[variable];
    // 사운드 선택은 브라우저에 저장해 새로고침 후 다시 묻지 않는다 (TheAside 참조)
    if( variable === 'soundOn' ){
      try { localStorage.soundOn = state.soundOn ? '1' : '0'; } catch (e) { /* 저장 불가 환경은 무시 */ }
    }
    await beepSound('success');
  },
  /**
   * 다크/라이트 모드 전환. 헤더 토글 버튼이 부른다.
   * 선택은 브라우저(localStorage.darkMode)에 남겨 새로고침·팝업창에서도 유지된다.
   * (서버 system-info 의 darkMode 는 기본값 역할만 하고, 저장된 선택이 있으면 그것을 쓴다 - getFrontMode 참조)
   */
  setDarkMode (state, on) {
    state.darkMode = !!on;
    try { localStorage.darkMode = on ? '1' : '0'; } catch (e) { /* 저장 불가 환경은 무시 */ }
  },
  // ------------ below --- added for application ------------
  get (state, key) {
    return state[key];
  },
  async LOGIN (state, user) {
    // console.log( "**********************  store-mutation-LOGIN  **********************");
    state.baseReady = false;
    state.user = user;
    localStorage.user = JSON.stringify(user);
    state.expireSecIn = (user.tokenExpireMin * 60) - 5;
    axios.defaults.headers.common['x-access-token'] = user.accessToken;
    state.isAuth = true;

    // console.log( "**********************  store-mutation-LOGIN --- state.user ---", state.user);

    await sleep(500);
    await initBase();
    await sleep(500);


    if( !Object.keys(state.codeMaps).length ) await sleep(200);
    if( !Object.keys(state.codeOpts).length ) await sleep(200);
    if( !Object.keys(state.area).length ) await sleep(200);
    if( !Object.keys(state.tanks).length ) await sleep(200);

    await connectWebSocket(user.centerCode, user.accessToken);

    // commit() 은 비동기 뮤테이션을 기다리지 않는다. 화면 전환은 이 플래그를 보고 기다린다 (waitBaseReady)
    state.baseReady = true;
  },

  setToken (state, auth) {
    // console.log("========= store-mutation-setToken ========= ");
    state.user.accessToken = auth.accessToken;
    state.user.tokenExpireMin = auth.tokenExpireMin;
    state.expireSecIn = (auth.tokenExpireMin * 60) - 5;
    localStorage.user = JSON.stringify(state.user);
    setTimeout( async ()=>{
      await connectWebSocket(state.user.centerCode, state.user.accessToken);
    }, 2000 );

  },

  async LOGOUT (state, code) {
    // console.log("========= store-mutation-LOGOUT ========= code------->", code);
    try{
      state.user.accessToken = null;
      state.isAuth = false;
      state.user = cloneVar( _user );
      // $user = cloneVar( _user );
      // $isAuthed = false;
      state.socket = null;
      state.baseReady = false;
      delete localStorage.user;
      delete localStorage.soundOn; // 다음 로그인 때 사운드 설정을 다시 묻는다
      await router.push({name:'Login', params: {code} }, );

    }catch(err){
      console.error( "========= store-mutation-LOGOUT ----->logout error--->", err );
    }
  }

  // ------------ above --- added for application ------------

}

const classMap = { SA: 1, SM: 2, SS:3 };

const actions = {
  async LOGIN ({commit}, {userId, userPwd }) {
    // console.log( "*** ------------------- store----action-----LOGIN -------------------- ***");

    const param = {
      loginId: userId,
      loginPwd: userPwd,
    };

    // const encodedParam = qs.stringify( param );
    // const serverUrl = $baseURL;
    try{
      const rs = await apiAuth( param );
      // console.log("############ STORE_ACTION___LOGIN  ===============>  result: ", rs );

      if( rs.code===200 ) {
        if (!rs.result.accessToken)
          throw new Error("no Access Token");

        axios.defaults.headers.common['x-access-token'] = rs.result.accessToken;

        const {user} = rs.result;

        if (user) new Error("cannot get user info");
        const {accessToken} = rs.result;

        const commitUser = {
          _id: user._id,
          id: user.userId,
          nick: user.nick,
          name: user.name,
          position: user.position,
          role: user.role,
          areas: user.areas,
          email: user.email,
          hpNo: user.hpNo,
          centerCode: user.centerCode,
          wgCode: user.wgCode,
          tokenExpireMin: user.tokenExpireMin,
          accessToken: accessToken,
          userClass: classMap[user.role]
        };

        // console.log('################ STORE_ACTION___LOGIN ----user---------->', commitUser);

        commit('LOGIN', commitUser);
      }

      return rs;

    }catch(err){
      console.error("################ STORE___ACTION___LOGIN error: ", err );
      // alert("SYSTEM NOT Ready...try again");
      // commit('LOGOUT');
      throw err;
    }

  },

  async LOGOUT ({commit}, code) {
    // console.log('################ STORE_ACTION___LOGOUT ################ code =>', code);
    try{
      if(!code) code = '0000';
      if( axios.defaults.headers.common['x-access-token'] ){
        const rs = await apiLogout();
        console.log( "################ STORE_ACTION___LOGOUT ----->logout result--->", rs );
      }

      if(state.socket){
        // console.log( "################ STORE_ACTION___LOGOUT-----> socket: ", state.socket );
        state.socket.removeAllListeners();
        state.socket.disconnect();
      }
      await commit('LOGOUT', code+'');

    }catch(err){
      console.error("################ STORE_ACTION___LOGOUT Error:", err)
    }finally{
      axios.defaults.headers.common['x-access-token'] = undefined;
    }

  },

  async refreshToken({commit}) {
    // console.log('################ STORE_ACTION___refreshToken ################');
    const rs = await refreshToken();
    if(rs.code===200){
      axios.defaults.headers.common['x-access-token'] = rs.result.accessToken;
      await commit('setToken', rs.result); // mutation call
      // await commit('LOGIN', rs.result); // mutation call
      return true;
    }else{
      return false;
    }
  },

  async setLoginState({commit}, user){
    try{
      axios.defaults.headers.common['x-access-token'] = user.accessToken;
      const rs = await apiAuthMe();
      // console.log( "@@@@@@@@@@ setLoginState() --- apiAuthMe()---------------> result --------->", rs );
      if( rs.code===200 ) {
        if (!rs.result.accessToken)
          throw new Error("no Access Token");

        axios.defaults.headers.common['x-access-token'] = rs.result.accessToken;
        const {user} = rs.result;

        if (user) new Error("cannot get user info");

        const commitUser = {
          _id: user._id,
          id: user.userId,
          nick: user.nick,
          name: user.name,
          position: user.position,
          role: user.role,
          areas: user.areas,
          email: user.email,
          hpNo: user.hpNo,
          centerCode: user.centerCode,
          accessToken: rs.result.accessToken,
          tokenExpireMin: rs.result.tokenExpireMin,
          userClass: classMap[user.role]
        };



        // console.log('@@@@@@@@@@ setLoginState() ----> commit user---------->', commitUser);
        await commit('LOGIN', commitUser);
        return true;

      } else {
        commit('LOGOUT', 'E401');
        return false;
      }
    }catch(err){
      console.error( "@@@@@@@@@@ setLoginState ------------> ", err.message );
      commit('LOGOUT', 'E500');
      throw err;
    }
  }
};


export default new Vuex.Store({
  state,
  mutations,
  actions
})
